<template>
  <div id="Waves">
    <!-- Header -->
    <div class="header py-7 py-lg-8 pt-lg-9">
      <b-container class="container">
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 id="welcome" class="text-white">Welcome</h1>
              <p class="text-lead text-white">Forgot Password</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
  

    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8" >
          <b-card no-body class="bg-secondary border-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Enter your username and a confirmation code will be sent to the phone number registered with your account.</small>
              </div>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">

                  <b-input-group class="mb-4">
                      <b-input-group-prepend>
                        <b-button :variant="validationUsername?'outline-success': 'outline-danger'">
                        <i class="fa fa-user"></i>
                        </b-button>
                      </b-input-group-prepend>
                      <b-form-input 
                        id="username" 
                        v-model="model.username"
                        :state="validationUsername" 
                        placeholder="Input Username"
                        aria-describedby="username-feedback"
                      ></b-form-input>
                      <b-form-invalid-feedback id="username-feedback" :state="validationUsername" >
                        Input valid username
                      </b-form-invalid-feedback>
                  </b-input-group>
                  <div class="text-center w-100">
                    <b-button type="submit" variant="primary" class="mt-4 w-100">Send Code</b-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>

  import AuthService from "@/common/api-services/auth-service";

  export default {
    name: 'register',
    data() {
      return {
        model: {
          username: '',
        }
      }
    },
    computed: {
      validationUsername() {
		  	return (this.model.username.length > 0 && !this.model.username.includes(' '));
		  }
    },
    mounted() {
      this.$root.$emit('renderBackground', true);
    },
    methods: {
      onSubmit() {
        if (this.validationUsername) {
          AuthService.forgetPassword(this.model.username).then(res => {
            if (res) {
              this.$root.$emit('sendUserName', this.model.username);
              this.$router.push({'name': 'Reset Password', 'params': {username: this.model.username}})
            }
          })
        }
      }
    }

  };
</script>
